module.exports = __webpack_public_path__ + "img/mentalSkills.0f044ae6.png";